export default "__VITE_ASSET__32cd57b2__"